import { Route, Routes } from 'react-router-dom';
import HomePage from './components/Pages/home';
import Loyout from './components/loyout/loyout';
import PrivacyPolicyPage from './components/Pages/PrivacyPolicyPage';
import AboutPage from './components/Pages/AboutPage';
import PetsPage from './components/Pages/PetsPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={
        <Loyout>
          <HomePage />
        </Loyout>
      } />
      <Route path="/privacy-policy" element={
        <Loyout>
          <PrivacyPolicyPage />
        </Loyout>
      } />
      <Route path="/about" element={
        <Loyout>
          <AboutPage />
        </Loyout>
      } />
      <Route path="/pets" element={
        <Loyout>
          <PetsPage />
        </Loyout>
      } />
    </Routes>
  );
}

export default App;
